var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBigLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.966,
    height: 18,
    viewBox: "0 0 10.966 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.681 17.631L.301 9.738a1 1 0 010-1.431L8.681.384a1.381 1.381 0 011.911 0 1.23 1.23 0 010 1.761L3.343 9.004l7.253 6.833a1.23 1.23 0 010 1.761 1.381 1.381 0 01-1.911.03z"
  })));
}
export default SvgArrowBigLeft;